import FreeContentService from '@/services/api/free-contents'
import FreeAreaService from '@/services/free-area/free-area'
import { InstanceResolverInterface } from '@/util/instanceResolver'

abstract class HostFreeAreaService extends FreeAreaService {
  constructor (
    private readonly instance: InstanceResolverInterface,
    freeContentService: FreeContentService
  ) {
    super(freeContentService)
  }

  private get contentsDirectory() {
    /**
     * SINGLEインスタンスの場合、フリーエリアの取得はブランドパーツとして取得する.
     * @see https://github.com/my-color/front/issues/5468#issuecomment-879962688
     * @see FreeAreaService.createForHost
     */
    return this.instance.isMulti() ?
      [
        'company',
        'free',
        'mycolorpage',
        'parts',
      ] :
      [
        'company',
        'free',
        'brandpage',
        'parts',
        this.instance.getSingleBrand(),
      ]
  }

  protected createContentsPath(contentsName: string): string {
    return [
      ...this.contentsDirectory,
      contentsName,
    ].join('.')
  }
}

export default HostFreeAreaService
